import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { GetCandidatePie } from "../../../../apiServices";
import AdminPieChartFilter from "./AdminPieChartFilter";
import { useSelector } from "react-redux";
import AdminTableFilter from "../AdminTableFilter";
import { DMMMYYYY_formate } from "../../../../utility";

ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

function AdminOverallPie() {
  const JobsFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateDashboard
  );
  const startDate = useSelector(
    (state) =>
      state.CandidateDashboardFilterDetails.CandidateDashboard.startDate
  );
  const endDate = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateDashboard.endDate
  );
  // console.log(startDate, "startdate");

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ["#3d85c6", "#E65122", "#169c50"],
        hoverOffset: 4,
      },
    ],
  });

  const fetchData = async () => {
    const data = await GetCandidatePie(JobsFilter);

    let totalJoined = 0;
    let totalLeft = 0;
    let totalCurrentlyWorking = 0;

    // Sum the counts from all interviews
    data.interviews.forEach((interview) => {
      totalJoined += parseInt(interview.joined_count, 10);
      totalLeft += parseInt(interview.left_count, 10);
      totalCurrentlyWorking += parseInt(interview.currently_working, 10);
    });

    // Filter out zero values and their corresponding labels
    const labels = ["Joined", "Left", "Currently Working"];
    const values = [totalJoined, totalLeft, totalCurrentlyWorking];
    const backgroundColor = ["#3d85c6", "#E65122", "#169c50"];

    const filteredValues = values.filter((value) => value !== 0);
    const filteredLabels = labels.filter((label, index) => values[index] !== 0);
    const filteredBackgroundColor = backgroundColor.filter(
      (color, index) => values[index] !== 0
    );

    setChartData({
      labels: filteredLabels.length > 0 ? filteredLabels : ["No Data"], // Show a "No Data" label if all values are zero
      datasets: [
        {
          data: filteredValues.length > 0 ? filteredValues : [0], // If all values are zero, set it to 0
          backgroundColor: filteredBackgroundColor,
          hoverOffset: 4,
        },
      ],
    });
  };

  useEffect(() => {
    fetchData();
  }, [JobsFilter]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        color: "white",
        font: {
          weight: "bold",
          size: 16,
        },
        formatter: (value) => {
          return value < 10 ? `0${value}` : value;
        },
        // Hide data labels if there are no non-zero values
        display: (context) => context.dataset.data.some((value) => value !== 0),
      },
    },
    cutout: "60%",
    rotation: -Math.PI / 2,
  };

  return (
    <div>
      <div className="text-center mb-1">
        <b>
          <DMMMYYYY_formate dateValue={startDate} />
        </b>{" "}
        to{" "}
        <b>
          <DMMMYYYY_formate dateValue={endDate} />
        </b>
      </div>
      <div
        style={{
          width: "390px",
          height: "390px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Doughnut data={chartData} options={options} />
      </div>
    </div>
  );
}

export default AdminOverallPie;
